MeetOurRunners = (function ($){
    /**
     * News functionality for
     */
    var MeetOurRunners = {
        init : function (selector) {
            this.runnersArea = $(selector);
            this.postFiltersArea = $('.post-filters-container');

            this.loader = document.createElement('div');
            this.loader.className = 'loading';

            $(this.runnersArea).prepend(this.loader);

            this.pageNum = 1;
            this.maxNumPages = $('.card-columns',this.runnersArea)[0].dataset.maxPages;

            this.filters = {};
            $('.tab-content a',this.postFiltersArea).on('click',this.handleFilterClick.bind(this));
            $('.load-more',this.runnersArea).on('click',this.handleLoadMoreClick.bind(this));
        },
        handleFilterClick: function (event) {
            var target = event.currentTarget;
            if(target.classList.contains('active')){
                this.removeFilter(target.dataset.type,target.dataset.id);
                target.classList.remove('active');
            } else {
                this.addFilter(target.dataset.type,target.dataset.id);
                target.classList.add('active');
            }
            this.pageNum = 1;
            this.fetchPosts(this.filters,this.updatePosts.bind(this));
        },
        addFilter: function (type,id) {
            if(type in this.filters) {
                if(this.filters[type].indexOf(id) === -1) {
                    this.filters[type].push(id);
                }
            } else {
                this.filters[type] = [id];
            }
        },
        removeFilter: function (type,id) {
            if(type in this.filters) {
                if(this.filters[type].indexOf(id) !== -1) {
                    this.filters[type].splice(this.filters[type].indexOf(id), 1);
                }
            }
        },
        updatePosts: function (data) {
            $('.card-columns',this.runnersArea).html(data.html);

            this.setLoading(false);
        },
        fetchPosts: function (filters,callback) {
            this.setLoading(true);
            $.ajax({
                method: 'get',
                url: ajaxurl,
                data : {
                    action: 'getmeetourrunnersposts',
                    filters: filters,
                    paged: this.pageNum
                }
            })
            .success( function (response) {
                this.maxNumPages = response.maxPages;
                callback(response);
                this.updateLoadMore();
            }.bind(this))
            .error( function (){
                this.setLoading(false);
            }.bind(this));
        },
        handleLoadMoreClick: function () {
            this.pageNum++;
            this.fetchPosts(this.filters,this.addPosts.bind(this));
        },
        setLoading: function (loading) {
            if(loading === false) {
                $('.loading').hide();
            } else {
                $('.loading').show();
            }
        },
        addPosts: function (data) {
            $('.card-columns',this.runnersArea).append(data.html);
            this.setLoading(false);
        },
        updateLoadMore: function () {
            if(this.pageNum >= this.maxNumPages) {
                $('.load-more',this.runnersArea).hide();
            } else {
                $('.load-more',this.runnersArea).show();
            }
        },

    };
    return MeetOurRunners;
})(jQuery);
